import { useEffect, useState } from "react";
import { getProjectsApi, getProjectByIdApi, createProjectApi, updateProjectApi,searchProjectsApi, deleteProjectApi,getProjectBySlugApi } from "../apiServices/projectServices";
import { getProjectsHavingFormsApi, } from "../apiServices/projectFormRelationServices";
const useProjects = (params = {}) => {
  const [projects, setProjects] = useState([]);
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(false);
  const [projectBySlug, setProjectBySlug] = useState(null);
  const fetchProjects = async () => {
    try {
      setLoading(true);

      let res;

      if (params?.search && params.search.trim() !== "") {
        res = await searchProjectsApi(params.search);
      } else {
        if(params?.onlyHavingForms){
          res= await getProjectsHavingFormsApi();
        }else{
          res= await getProjectsApi(params);
        }
      }

      setProjects(res?.data?.projects || res?.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  
  const fetchProjectBySlug = async (slug) => {
    try {
      setLoading(true);
      const res = await getProjectBySlugApi(slug);
      setProjectBySlug(res?.data || null);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  const fetchProjectById = async (id) => {
    try {
      setLoading(true);
      const res = await getProjectByIdApi(id);
      setProject(res?.data || null);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const createProject = async (data) => {
    const res = await createProjectApi(data);
    await fetchProjects();
    return res;
  };

  const updateProject = async (id, data) => {
    const res = await updateProjectApi(id, data);
    await fetchProjects();
    return res;
  };

  const deleteProject = async (id) => {
    await deleteProjectApi(id);
    await fetchProjects();
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchProjects();
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [JSON.stringify(params)]);

  return { projects, project, loading, fetchProjects, fetchProjectById, createProject,projectBySlug,fetchProjectBySlug, updateProject, deleteProject, };
};

export default useProjects;